import { Request } from '../lib';

export default {
  retrieve: (params: object) => {
    return Request.get('/payment/dashboard/transactions', params);
  }
};
